import { ListableInfo } from '@ics-portal/guardian';
import { type Maybe } from 'graphql/jsutils/Maybe';
import { type ReactNode } from 'react';

interface UrlListableInfoProps {
    label: string;
    url: Maybe<string>;
}

export function UrlListableInfo({
    label,
    url,
}: UrlListableInfoProps): ReactNode {
    return (
        <ListableInfo
            size="md"
            valueStyle={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: 'blue',
            }}
            label={label}
            value={
                url ? (
                    <a href={url} target="_blank" rel="noreferrer">
                        {url}
                    </a>
                ) : (
                    '-'
                )
            }
        />
    );
}
